import { useEffect, useState } from 'react';
import InspirationProductImage from '@components/InspirationProductImage/InspirationProductImage';
import styles from '@features/cms/components/inspirations/InspirationProductGalleryDuo/InspirationProductGalleryDuo.styles';
import { IInspirationProductGalleryDuo } from '@features/cms/typescript';
import theme from '@styles/theme';
type PropsType = {
  data: IInspirationProductGalleryDuo;
  defaultBackground?: string;
};
const InspirationProductGalleryDuo = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const [mobilePadding, setMobilePadding] = useState<string[]>([]);
  useEffect(() => {
    const padding: string[] = [];
    data.images.forEach(image => {
      padding.push(image.variant?.includes('Small') ? '40px' : '24px');
    });
    setMobilePadding(padding);
  }, []);
  return <section id={data.code} sx={styles.inspirationDuoSection(data.background || defaultBackground, mobilePadding)} data-testid={data.code}>
      {data.images.map(image => <div key={image.itemId} sx={styles.duoSectionImageBox(image.justifyContent)} data-testid="inspiration-product-gallery-duo-image">
          <InspirationProductImage imageData={image} />
        </div>)}
    </section>;
};
export default InspirationProductGalleryDuo;